import React, { useState } from 'react';
import EnviarArquivo from './EnviarArquivo';
import ConsultarEnvios from './ConsultarEnvios';

import * as S from './styles';

function MovimentacoesPorArquivo({ location: { graphFilter } }) {
    const [activeTab, setActiveTab] = useState(graphFilter ? '2' : '1');

    return (
        <S.Container>
            <S.StyledTabs activeKey={activeTab} onChange={setActiveTab} defaultActiveKey="1">
                <S.StyledTabPane tab="Enviar arquivo" key="1">
                    <EnviarArquivo setActiveTab={setActiveTab} />
                </S.StyledTabPane>
                <S.StyledTabPane tab="Consultar retornos do processamento" key="2">
                    <ConsultarEnvios graphFilter={graphFilter} />
                </S.StyledTabPane>
            </S.StyledTabs>
        </S.Container>
    );
}

export default MovimentacoesPorArquivo;
